import { trpc } from "../trpc";

export function useConvertToSharedFolder() {
  const utils = trpc.useUtils();

  const { mutate, isPending } = trpc.folder.convertToShared.useMutation({
    onMutate: () => {
      // Cancel any outstanding queries so things are overwritten
      utils.folder.folderTree.cancel();

      // Skip optimistic updates for right now.
      // Optimistic updates sometimes cause the folder to be immediately removed
      // from the DOM which cancels success toasts. We should revisit this later.
      // Slack: https://zapier.slack.com/archives/C06VAQLNU4E/p1723656611031549
    },
    onSettled: () => {
      // Refetch the queries to get fresh data
      utils.folder.folderTree.invalidate();
    },
  });

  return {
    convertToSharedFolder: mutate,
    isPending,
  };
}
